import { useEffect, useState } from "react";
import Select from 'react-select';
import DayJS from 'react-dayjs';
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import StyledCard from 'components/StyledCard';
import useAuth from "../../hooks/useAuth";
import useAPI from "../../hooks/useAPI";
import PageLayout from "components/PageLayout";
import BackButton from "components/BackButton";
import { useParams } from "react-router-dom";
import useStyles from './styles';
import { getPersonName } from 'utils/helper';
import { toast } from 'react-toastify';


const Reassign = () => {
  const { appointmentId } = useParams()
  const [appointment, setAppointment] = useState([]);
  const [technician, setTechnician] = useState();
  const [users, setUsers] = useState([])
  const api = useAPI();
  const styles = useStyles()


  useEffect(() => {
    api
    .get('/users')
    .then(res => {
      setUsers(
        res.data.users
          .filter(user => user.role.includes('tech.'))
          .map(user => ({ label: getPersonName(user), value: user._id }))
      )
      api
        .get(`/appointments/${appointmentId}`)
        .then(res => {
          setAppointment(res.data.appointment);
          setTechnician({ value: res.data.appointment.technician?._id, label: getPersonName(res.data.appointment.technician) })
        })
        .catch(err => console.log(err))
    })
    .catch(err => console.log(err))
    // eslint-disable-next-line
  }, [])
  
  const reassignJob = () => {
    api
      .put(`/appointments/${appointmentId}`, { technicianId: technician.value, status: {_id: 'scheduled'} })
      .then(() => toast.success(`Successfully reassigned to ${technician.label}.`))
      .catch((error) => toast.error(error.toString() || 'An unexpected error occurs, please contact administrator'))
      ;
  }

  return (
    <PageLayout title="Reassign Job">
      <Container maxWidth="md">
        <StyledCard variant="outlined" key={appointment._id}>     
          <Box display="flex">
            <Typography variant="h3" className={styles.heading}>Edit Job Information</Typography>
            <BackButton url='/manage' />
          </Box>
          <Box my={3}>
            <Box display="flex" alignItems="center" my={1}>
              <Box className={styles.label} width={150}>Start Time:</Box>
              <Typography className={styles.paragraph}><DayJS format="MM/DD/YYYY">{ appointment.start }</DayJS></Typography>
            </Box>
            <Box display="flex" alignItems="center" my={1}>
              <Box className={styles.label} width={150}>End Time:</Box>
              <Typography className={styles.paragraph}><DayJS format="hh:mm a">{ appointment.start }</DayJS></Typography>
            </Box>
            <Box display="flex" alignItems="center" my={1}>
              <Box className={styles.label} width={150}>Technician:</Box>
              <Box width={250}>
                <Select
                  isClearable
                  placeholder="Technician"
                  options={users}
                  value={technician}
                  onChange={(value) => setTechnician(value)}
                  menuPortalTarget={document.body} 
                  styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                  />
              </Box>
            </Box>
          </Box>
          {
            appointment.customer && 
            <Box flex={1}>
              <Typography className={styles.customerParagraph}>{`${appointment.customer.firstName} ${appointment.customer.middleName} ${appointment.customer.lastName}`}</Typography>
              <Typography className={styles.customerParagraph}>{`${appointment.customer.streetNumber} ${appointment.customer.streetName}`} {appointment.customer.unit ? `UNIT ${appointment.customer.unit}` : ''}</Typography>
              <Typography className={styles.customerParagraph}>{`${appointment.customer.city}, ${appointment.customer.primaryPhone}`}</Typography>
              <Typography className={styles.customerParagraph}>Enrollment #: { appointment.customer.enrollment?.enrollmentNumber }</Typography>
            </Box>
          }
          <Box display="flex" justifyContent="end" mt={5}>
            <Button variant="contained" color="primary" onClick={() => reassignJob()}>
              Reassign
            </Button>
          </Box>
        </StyledCard>
      </Container>
    </PageLayout>
  );
};

const Page = () => {
  const { PrivateContent } = useAuth();
  return (
    <PrivateContent title="Reassign">
      <Reassign />
    </PrivateContent>
  );
};

export default Page;
